import React, {useContext} from "react";
import {Row} from "react-bootstrap";

import Challenge from "./challenge";
import Headline from "./common/headline";

import { AppContext } from "../App";

export default function Challenges() {

    const { data, setData } = useContext(AppContext);
    const {challenges, products, steps} = data;

    const toggleChallenges = (challenge) => {
        let newChallenges = challenges;

        products.map(product => {
          product.selected = true;
          product.disabled = false;

          return product;
        });

        challenge.selected = !challenge.selected;

        setData({
            challenges: newChallenges,
            ...data
        })
    }

    const clearChallenges = () => {
        let clearedChallenges = challenges.map(challenge => {
            challenge.selected = false;

            return challenge;
        });

        let clearedProducts = products.map(product => {
            product.selected = true;
            product.disabled = false;

            return product;
        });

        let stepsInitialTitle = 'Select mAb Workflow step';

        let clearedSteps = steps.map(step => step.selected = false);

        setData({
            challenges: clearedChallenges,
            products: clearedProducts,
            steps: clearedSteps,
            ...data,
            stepsTitle: stepsInitialTitle
        })
    }

    const renderChallenges = challenges
        .map((challenge) => ( <Challenge challenge={challenge} toggleChallenges={toggleChallenges} key={challenge.id}/> ));

    return (
        <div className="workflow-challenges">
            <Headline counter={1} title={'Select challenges'} filters={true} clearChallenges={clearChallenges} />
            <Row>
                {renderChallenges}
            </Row>
        </div>
    );
}

